import React from 'react';
import About from './components/About';
import Services from './components/Services';
import Portfolio from './components/Portfolio';
import ModernFooter from './components/ModernFooter';
import './App.css';

function App() {
  return (
    <div className="App">
      <About />
      <Services />
      <Portfolio />
      <ModernFooter />
    </div>
  );
}

export default App;
